
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: 'TabUserMsg',
components: {
Tab,
TabItem,
Divider,
XButton
},
props: {
list: {
type: Array,
default: null
},
selectedIndex: {
type: Number,
default: 0
}
},
computed: {
getPosition () {
return this.scrollPos;
}
},
data () {
return {

tabWidth: document.body.clientWidth * 0.80,
scrollPos: 0
}
},
created () {
window.addEventListener('scroll', this.handler)
},
beforeDestroy () {
window.removeEventListener('scroll', this.handler)
},
methods: {
handler () {
this.scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
},

onItemClick (keyword, index) {
this.$emit('click-bar-item', index, keyword)
},
}
}



// WEBPACK FOOTER //
// ./src/components/tab/TabUserMsg.vue